import { Box, InputLabel } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { AerosDatePicker } from "@/components/UiKit"
import { FIELD_LABEL_CLASSES } from "@/constants/forms"

interface CertificationDateFieldProps {
  label?: string
  name?: string
}

const CertificationDateField: FC<CertificationDateFieldProps> = ({
  name = "certificationDate",
  label = "Certification Date",
}) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box className='mt-6' data-testid={name}>
          <InputLabel id='type' className={FIELD_LABEL_CLASSES}>
            {label}
            <span className='text-red-600'>*</span>
          </InputLabel>
          <AerosDatePicker
            {...field}
            value={field.value}
            onChange={field.onChange}
            error={!!error}
            helperText={error?.message}
            required
            data-testid='certification-date-picker'
          />
        </Box>
      )}
    />
  )
}

export default CertificationDateField
